/**
 * CSS transition support
 *
 * CSS transitionのサポートチェックとコールバックイベント名を取得
 *
 * @return {object}
 */

'use strict';

module.exports = (function () {
  var checkElement = document.createElement('div');
  var use = {};

  if ('transition' in checkElement.style) {
    use.support = true;
    use.prefix = '';
    use.end = 'transitionend';
  } else if ('-webkit-transition' in checkElement.style) {
    use.support = true;
    use.prefix = '-webkit-';
    use.end = 'webkitTransitionEnd';
  } else {
    use.support = false;
    use.prefix = '';
    use.end = 'transitionend';
  }
  return use;
})();
